import { Experiment } from '@grammarly/experimentation-js-sdk'

/**
 * PixelExperiment extends the base Experiment class to enable pixel-based assignment tracking.
 * When assigned during SSR, these experiments will trigger pixel injection for client-side tracking.
 */
export class PixelExperiment<Treatments extends string = string> extends Experiment<Treatments> {
  /**
   * Flag to identify this as a pixel experiment
   */
  readonly isPixelExperiment = true

  constructor(name: string, experiences: readonly Treatments[]) {
    super(name, [...experiences])
  }

  /**
   * Type guard to check if an experiment is a PixelExperiment
   */
  static isPixelExperiment(experiment: Experiment<any>): experiment is PixelExperiment<any> {
    return 'isPixelExperiment' in experiment && experiment.isPixelExperiment === true
  }
}
